import type { OrganizationAccess, Permission, Viewer } from '@crm/contracts';

import { useViewer } from '../api/queries';

/**
 * The viewer's access to an organization. Global and organization admins may do
 * everything; other members what their position's permissions allow.
 */
export function organizationAccess(viewer: Viewer | null, organizationId: number) {
  const access: OrganizationAccess | undefined = viewer?.organizations.find(
    (item) => item.id === organizationId,
  );
  const canManage = Boolean(viewer?.isGlobalAdmin || access?.isAdmin);
  return {
    access,
    isMember: Boolean(viewer?.isGlobalAdmin || access),
    canManage,
    can: (permission: Permission) => canManage || Boolean(access?.permissions.includes(permission)),
  };
}

export function useOrganizationAccess(organizationId: number) {
  return organizationAccess(useViewer(), organizationId);
}
